/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import styled from 'styled-components'

const WhatToLookFor = ({ className }) => (
  <div className={`${className} position-relative py-9`}>
    <div className="bg--blue-chev north" />
    <div className="position-relative">
      <div className="container">
        <div className="h2 white">Benefits of Online Education</div>
        <div className="row">
          <div className="col-12 col-lg-4">
            <div className="h3 white">Comfort</div>
            <p className="white">
              Opting for an online education means you don't have to sit at a desk in a classroom. Though some programs
              require an on-site externship with a set schedule, the coursework itself comes in a convenient online
              platform and any issues can be handled over the phone or via email. Don't worry about getting dressed for
              class &mdash; enjoy learning from the couch if you'd like.
            </p>
          </div>
          <div className="col-12 col-lg-4">
            <div className="h3 white">Pace</div>
            <p className="white">
              Earn an education on your time. Apart from externships, which typically have fixed schedules, you can
              avoid the more rigid structure of a physical classroom and have your coursework fit around your schedule
              &mdash; so long as you meet the deadlines set by instructors of course. Busy with the kids in the morning?
              Complete your course tasks in the evening. Working a nightshift? Enjoy a cup of coffee from home while you
              learn.
            </p>
          </div>
          <div className="col-12 col-lg-4">
            <div className="h3 white">Attention</div>
            <p className="white">
              Students in large classrooms and lecture settings may not get the attention needed for them to
              academically succeed. They might feel lost in the shuffle. With an online education, online guided
              discussions can help clarify coursework, and conversations with instructors via email can enhance your
              student experience.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default styled(WhatToLookFor)``

// TODO: Vertical spacing.
